<template>
  <div class="wrapper">
    <div class="wrapper-body">
      <div class="collapse_card">
        <div class="collapse-trigger">
          <div class="card-header">
            <p class="card-header-title">Email & Copyright Text</p>
            <b-button type="is-primary" outlined @click="editEmailCopy()">EDIT EMAIL,LOCATION & COPYRIGHT TEXT</b-button>
          </div>
          <div class="collapse-content">
            <div class="card-content">
              <h1 class="diffHead">Email</h1>
              <p class="diffParagraph">{{ profile.emailCopyright.email }}</p>
              <br>
              <h1 class="diffHead">Copyright Text</h1>
              <p class="diffParagraph">{{ profile.emailCopyright.copyrightText }}</p>
              <h1 class="diffHead">Location</h1>
              <p class="diffParagraph">{{ profile.emailCopyright.location }}</p>
            </div>
          </div>
        </div>
      </div>
      <b-collapse class="collapse_card" animation="slide" aria-id="contentIdForA11y3">
        <template #trigger="props">
          <div class="card-header" role="button" aria-controls="contentIdForA11y3" :aria-expanded="props.open">
            <p class="card-header-title">
              About Us
            </p>
            <b-button type="is-primary" outlined @click="editAbout()">EDIT ABOUT US</b-button>
            <a class="card-header-icon">
              <b-icon :icon="props.open ? 'menu-down' : 'menu-up'">
              </b-icon>
            </a>
          </div>
        </template>
        <div class="card-content">
          <div class="content" v-html="profile.about"></div>
        </div>
      </b-collapse>
      <b-collapse class="collapse_card" animation="slide" aria-id="contentIdForA11y3">
        <template #trigger="props">
          <div class="card-header" role="button" aria-controls="contentIdForA11y3" :aria-expanded="props.open">
            <p class="card-header-title">
              Terms & Conditions
            </p>
            <b-button type="is-primary" outlined @click="editTerms()">EDIT TERMS & CONDITIONS</b-button>
            <a class="card-header-icon">
              <b-icon :icon="props.open ? 'menu-down' : 'menu-up'">
              </b-icon>
            </a>
          </div>
        </template>
        <div class="card-content">
          <div class="content" v-html="profile.termsConditions"></div>
        </div>
      </b-collapse>
      <b-collapse class="collapse_card" animation="slide" aria-id="contentIdForA11y3">
        <template #trigger="props">
          <div class="card-header" role="button" aria-controls="contentIdForA11y3" :aria-expanded="props.open">
            <p class="card-header-title">
              Payment Terms
            </p>
            <b-button type="is-primary" outlined @click="editPaymentTerms()">EDIT PAYMENT TERMS</b-button>
            <a class="card-header-icon">
              <b-icon :icon="props.open ? 'menu-down' : 'menu-up'">
              </b-icon>
            </a>
          </div>
        </template>
        <div class="card-content">
          <div class="content" v-html="profile.paymentTerms"></div>
        </div>
      </b-collapse>
      <b-collapse class="collapse_card" animation="slide" aria-id="contentIdForA11y3">
        <template #trigger="props">
          <div class="card-header" role="button" aria-controls="contentIdForA11y3" :aria-expanded="props.open">
            <p class="card-header-title">
              Privacy Policy & Safety
            </p>
            <b-button type="is-primary" outlined @click="editPrivacy()">EDIT PRIVACY POLICY & SAFETY</b-button>
            <a class="card-header-icon">
              <b-icon :icon="props.open ? 'menu-down' : 'menu-up'">
              </b-icon>
            </a>
          </div>
        </template>
        <div class="card-content">
          <div class="content" v-html="profile.privacyPolicy"></div>
        </div>
      </b-collapse>
    </div>
    <editEmail v-if="edit_emailCopyright" @close="edit_emailCopyright = false" :value="profile.emailCopyright"
      @success="onEditEmail()">
    </editEmail>
    <editAboutUs v-if="edit_about" @close="edit_about = false" :value="profile.about" @success="onEditAbout()">
    </editAboutUs>
    <editTermsConditions v-if="edit_termsConditions" @close="edit_termsConditions = false"
      :value="profile.termsConditions" @success="onEditTerms()">
    </editTermsConditions>
    <editPaymentTerms v-if="edit_paymentTerms" @close="edit_paymentTerms = false" :value="profile.paymentTerms"
      @success="onEditPayment()">
    </editPaymentTerms>
    <editPrivacyPolicy v-if="edit_privacyPolicy" @close="edit_privacyPolicy = false" :value="profile.privacyPolicy"
      @success="onEditPrivacy()">
    </editPrivacyPolicy>
  </div>
</template>

<script>
import editEmail from './modals/website_static/edit_email_copyright.vue';
import editAboutUs from './modals/website_static/edit_about.vue';
import editTermsConditions from './modals/website_static/edit_terms_conditions.vue';
import editPaymentTerms from './modals/website_static/edit_payment_terms.vue';
import editPrivacyPolicy from './modals/website_static/edit_privacy_policy.vue';
export default {
  components: { editEmail, editAboutUs, editTermsConditions, editPaymentTerms, editPrivacyPolicy },
  data() {
    return {
      profile: {
        emailCopyright: {
          email: '',
          copyrightText: '',
          location: ''
        },
        about: "",
        termsConditions: "",
        paymentTerms: "",
        privacyPolicy: ""
      },
      edit_emailCopyright: false,
      edit_about: false,
      edit_termsConditions: false,
      edit_paymentTerms: false,
      edit_privacyPolicy: false
    }
  },
  mounted() {
    let vm = this;
    vm.getStatic();
  },
  methods: {
    editAbout() {
      let vm = this;
      vm.edit_about = true;
      console.log('About Us');
    },
    editEmailCopy() {
      let vm = this;
      vm.edit_emailCopyright = true;
    },
    editTerms() {
      let vm = this;
      vm.edit_termsConditions = true;
    },
    editPaymentTerms() {
      let vm = this;
      vm.edit_paymentTerms = true;
    },
    editPrivacy() {
      let vm = this;
      vm.edit_privacyPolicy = true;
    },
    onEditEmail() {
      let vm = this;
      vm.edit_emailCopyright = false;
      vm.getStatic();
    },
    onEditAbout() {
      let vm = this;
      vm.edit_about = false;
      vm.getStatic();
    },
    onEditTerms() {
      let vm = this;
      vm.edit_termsConditions = false;
      vm.getStatic();
    },
    onEditPayment() {
      let vm = this;
      vm.edit_paymentTerms = false;
      vm.getStatic();
    },
    onEditPrivacy() {
      let vm = this;
      vm.edit_privacyPolicy = false;
      vm.getStatic();
    },
    getStatic() {
      let vm = this;
      vm.$store
        .dispatch('STATIC_GET')
        .then(response => {
          let profile = {
            emailCopyright: {
              email: response.data.return.email,
              copyrightText: response.data.return.copyrightText,
              location: response.data.return.location
            },
            about: response.data.return.aboutUs,
            termsConditions: response.data.return.termsAndConditions,
            paymentTerms: response.data.return.paymentTerms,
            privacyPolicy: response.data.return.privacyPolicySafety
          }
          vm.profile = profile
        })
        .catch(err => console.log(err))
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  overflow-y: auto;

  .wrapper-body {
    width: 100%;

    .collapse_card {
      width: 100%;

      &:not(:last-of-type) {
        border-bottom: 1px solid #ddd;
      }

      .collapse-trigger {
        .card-header {
          display: flex;
          align-items: center;
          padding: 1px 10px 1px 0;
          box-shadow: none;
          border-bottom: 1px solid #ddd;
          position: sticky;
          top: 0px;
          background-color: #fff;
          z-index: 99;
          overflow-x: auto;

          p.card-header-title {
            font-size: 19px;

            @media (max-width: 576px) {
              font-size: 16px;
              white-space: nowrap;
            }
          }
        }
      }

      .collapse-content {
        .card-content {
          padding: 15px 20px;
          transition: none !important;

          h1.diffHead {
            font-size: 18px;
            font-weight: 600;
          }

          p.diffParagraph {
            color: grey;
          }
        }
      }
    }
  }
}
</style>